import { authorBaseUrl as baseUrl } from "@/constants"
import Link from "next/link"
import { useEffect } from "react"
import brandLogo from "@/public/icons/BLOK_LOGO.svg"
import { getOmniLogoCondnlLink } from "@/utils/index"

const HeaderNavLogo = props => {
  const {
    data,
    columnClassNames,
    eventHandler: {
      store: { brandLogoImg = "" } = {},
      callbacks: {
        setBrandLogoImg = () => console.log("Event Not Defined"),
        toggleMenu = () => console.log("Event Not Defined"),
      } = {},
    } = {},
    isOmnichannel = false,
    omniQRParams = {},
    isQrService= false
  } = props

  useEffect(() => {
    if (data?.dataLayer?.[data?.id] && data?.dataLayer[data?.id]?.image) {
      const brandLogoPath = data?.dataLayer[data?.id]?.image["repo:path"]
      brandLogoPath && setBrandLogoImg(baseUrl + brandLogoPath)
    }
  }, [data])
  useEffect(() => {
    setBrandLogoImg(brandLogo?.src)
  }, [])
  return (
    <>
      {!isOmnichannel ? (
        <span
          className="gbh-hamber-menu icon-Hamburger"
          tabIndex="0"
          aria-label="Hamburger-menu"
          role="button"
          onClick={toggleMenu}
        ></span>
      ) : null}
      <div
        className={`cmp cmp-image ${
          data?.appliedCssClassNames ? data?.appliedCssClassNames : ""
        } ${columnClassNames ? columnClassNames : ""}`}
      >
        <a
          // coming from AEM
          href={getOmniLogoCondnlLink(data, isOmnichannel, omniQRParams, isQrService)}
          title={data?.alt}
          className="cmp-image--link"
        >
          <section>
            <img src={brandLogo.src} alt={data?.alt} />
          </section>
        </a>
      </div>
    </>
  )
}

export default HeaderNavLogo
